
var cartData;
var checkout_button = "input[name='checkout'], button[name='checkout'], [href$='checkout'], #PLW_checkout_button";
// var isNotParentMove = true;
var max_limit = 5000;

function set_payment_option(th) {
  document.getElementById("PLW_purchase-option-info-wrapper").style.display = 'none';
  if (th.id === "PLW_purchase-option-deposit-input") {
    document.getElementById("PLW_purchase-option-info-wrapper").style.display = 'block';
  }
}

document.addEventListener("DOMContentLoaded", function () {

    // Get the element with id "pay_later_init"
    const payLaterElement = document.getElementById('pay_later_init');

    if (payLaterElement) {
        // Find all matching checkout button elements
        const checkoutButtons = document.querySelectorAll(checkout_button);

        if (checkoutButtons.length > 0) {
            // Get the last matching checkout button element
            var lastCheckoutButton = checkoutButtons[checkoutButtons.length - 1];

            if(typeof isNotParentMove == "undefined"){
              lastCheckoutButton = lastCheckoutButton.parentNode;
            }
          
            // Insert the payLaterElement before the lastCheckoutButton
            lastCheckoutButton.parentNode.insertBefore(payLaterElement, lastCheckoutButton);
            
            // Make the element display as block
            payLaterElement.style.display = 'block';

            console.log('Element moved and displayed successfully.');
        } else {
            console.warn('No checkout button found to place the element before.');
        }
    } else {
        console.warn('Element with id "pay_later_init" not found.');
    }

          fetch('/cart.js')
          .then(response => {
              if (!response.ok) {
                  throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.json(); // Parse the response as JSON
          })
          .then(data => {

              const totalCartValue = data.total_price/100; // Assuming total cart value is 100

  if(totalCartValue>max_limit){
    document.getElementById("pay_later_init").style.display = "none";
  }else{
    document.getElementById("pay_later_init").style.display = "block";
  }
});

    if(typeof disableDefaultCheckout !== "undefined"){
      const checkoutButton = document.getElementById("PLW_checkout_button");
      const fullOption = document.getElementById("PLW_purchase-option-full");
      const depositOption = document.getElementById("PLW_purchase-option-deposit-input");
    
      function setButtonNameAttribute() {
        if (fullOption.checked) {
          checkoutButton.setAttribute("name", "checkout");
        } else if (depositOption.checked) {
          checkoutButton.removeAttribute("name");
        }
      }
    
      // Attach event listeners to both radio buttons
      fullOption.addEventListener("change", setButtonNameAttribute);
      depositOption.addEventListener("change", setButtonNameAttribute);
    
      // Set the initial state of the button
      setButtonNameAttribute();  
    }
    

    

    document.addEventListener("click", function(event) {
      if (event.target.matches(checkout_button)) {
            event.preventDefault(); // Prevent default action if needed (e.g., form submission or navigation)

            const purchase_option = document.querySelector('input[name="attributes[_PLW_cart_purchase_option]"]:checked')?.value;

            const selected_radio = document.querySelector('input[name="attributes[_PLW_cart_purchase_option]"]:checked');

            var deposit_fees = 0;

            if (selected_radio) {

              deposit_fees = selected_radio.getAttribute("data-deposit-fees");

            }

            if(typeof purchase_option == "undefined" || purchase_option == 'full'){
              window.location = "/checkout";
            }

          fetch('/cart.js')
          .then(response => {
              if (!response.ok) {
                  throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.json(); // Parse the response as JSON
          })
          .then(data => {

           
              // Process the cart data as needed
              data.items.forEach((item, index) => {
              console.log(item);
      
              if(typeof item.selling_plan_allocation !== "undefined"){
                  let discount_info = item.selling_plan_allocation.selling_plan.description.split("|");
      
                  let discount_amount = discount_info.slice(-1).pop();
      
                  let discounted_price = item.discounted_price/100;
      
                  if(discount_amount.includes("%")){
                      discount_amount = Number(discount_amount.replace("%", ''));
      
                      var new_discounted_price = (discount_amount/100) * discounted_price;
                  
                  }else{
                      discount_amount = Number(discount_amount);
                  
                      var new_discounted_price = discount_amount ;
                  }
      
                  data.items[index].discounted_price = new_discounted_price*100;
      
                  console.log('Cart data fetched successfully:', data);
                  
              }
                
              });
      
              cartData = data;

              // Prepare the data to send
              const cart_data = {
                        message: "Checkout button clicked",
                        cartData: JSON.stringify(cartData),
                        action: "create_draft_order_cart",
                        purchase_option: purchase_option,
                        deposit_fees: deposit_fees,
                        isCartDiscount: true
                    };
        
                    fetch('/apps/PLW/deposit', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(cart_data)
                    })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status}`);
                        }
                        return response.json(); // Parse JSON response if applicable
                    })
                    .then(responseData => {
        
                        if(typeof responseData.success.invoice_url !== "undefined"){
                            window.location = responseData.success.invoice_url;
                        }
                        console.log('Request successful:', responseData);
                    })
                    .catch(error => {
                        console.error('Request failed:', error);
                    });
          })
          .catch(error => {
              console.error('Failed to fetch cart data:', error);
          });
            
        }
    });
});

async function emitCartChanges() {
    const newCart = await fetchCart();
    const event = new CustomEvent("cart_changed", { detail: newCart });
    window.dispatchEvent(event);
}
async function fetchCart() {
  const response = await fetch('/cart.js');
  return response.json();
}
  
function observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        //console.log(entry);
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          emitCartChanges();
        }
      });
    });
  
    cartObserver.observe({ entryTypes: ["resource"] });
}

window.addEventListener("cart_changed", e => {
  
  var cart_data = e.detail;


  console.log(cart_data);

  // update text

  const totalCartValue = cart_data.total_price/100; // Assuming total cart value is 100

  if(totalCartValue>max_limit){
    document.getElementById("pay_later_init").style.display = "none";
  }else{
    document.getElementById("pay_later_init").style.display = "block";
  }
  
  updatePrices(totalCartValue);
  
  
});

function updatePrices(totalCartValue) {
    const percentageElement = document.getElementById("PLW_purchase-option-deposit-input");
    if (!percentageElement) {
        console.error("Percentage input element not found!");
        return;
    }


     // Extract percentage or fixed value
     const percentageText = percentageElement.value || percentageElement.innerText;
     const [value, type] = percentageText.split("-"); // Splitting value and type
     const extractedValue = parseFloat(value.trim()); // Extract numeric part

     if (isNaN(extractedValue)) {
         console.error("Invalid discount value!");
         return;
     }

     let discountValue = 0;
     
     // Determine if discount is percentage or fixed
     if (type === "percentage") {
         discountValue = (totalCartValue * extractedValue) / 100; // Calculate percentage discount
     } else if (type === "fixed") {
         discountValue = extractedValue; // Apply fixed discount
     } else {
         console.error("Invalid discount type! Expected 'percentage' or 'fixed'.");
         return;
     }

    // Extract percentage (assuming format like "10-percentage")
    // const percentageText = percentageElement.value || percentageElement.innerText;
    // const extractedPercentage = parseFloat(percentageText.split("-")[0]); // Get the numeric value before '-'

    // if (isNaN(extractedPercentage)) {
    //     console.error("Invalid percentage value!");
    //     return;
    // }

    // const discountValue = (totalCartValue * extractedPercentage) / 100; // Calculate percentage of total cart

    // Update elements with class "pay_now_price"
    document.querySelectorAll(".pay_now_price").forEach(element => {
        //let originalPrice = parseFloat(element.innerText.replace(/[^0-9.]/g, "")); // Extract numeric value
        let newPrice = discountValue; // Apply discount

        // Update element with new price
        element.innerText = newPrice.toFixed(2); // Format price
    });
}
observeCartChanges(); 
